import { render, staticRenderFns } from "./AppNetlifycms.vue?vue&type=template&id=36863cba&scoped=true&"
import script from "./AppNetlifycms.vue?vue&type=script&lang=js&"
export * from "./AppNetlifycms.vue?vue&type=script&lang=js&"
import style0 from "./AppNetlifycms.vue?vue&type=style&index=0&id=36863cba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36863cba",
  null
  
)

export default component.exports